import React, { useId } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import Flag from '@atlaskit/flag/flag';
import { FlagGroup } from '@atlaskit/flag/flag-group';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import { token } from '@atlaskit/tokens';

import { RovoCreditsIntlProvider } from '../i18n';

const messages = defineMessages({
	title: {
		id: 'rovo-credits.internal.credit-request-success-flag.title',
		defaultMessage: 'Request sent',
		description: 'Success flag title after a request for more Rovo credits is accepted.',
	},
	body: {
		id: 'rovo-credits.internal.credit-request-success-flag.body',
		defaultMessage: 'We sent your request for more credits to your organization admins.',
		description: 'Confirms that the organization admins were sent a request for more Rovo credits.',
	},
});

const SuccessFlag = ({ onDismiss }: { onDismiss: () => void }): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const id = useId();
	return (
		<FlagGroup>
			<Flag
				id={id}
				appearance="normal"
				title={formatMessage(messages.title)}
				description={formatMessage(messages.body)}
				icon={<StatusSuccessIcon label="" color={token('color.icon.success')} />}
				onDismissed={onDismiss}
			/>
		</FlagGroup>
	);
};

export const CreditRequestSuccessFlag = ({
	onDismiss,
}: {
	onDismiss: () => void;
}): React.JSX.Element => (
	<RovoCreditsIntlProvider>
		<SuccessFlag onDismiss={onDismiss} />
	</RovoCreditsIntlProvider>
);
